import { useEffect, useState } from "react";
import { ShemaJsonTemplate } from "types/SchemaJson";
import schemaJson from "../schema/SchemaJson";
import UISchema from "../schema/UISchema.json";
import useModalities from "./useEducationalUnits";

export default function useTemplate(create?: boolean) {
  const [template, setTemplate] = useState<ShemaJsonTemplate>();
  const { EducationalUnits } = useModalities();

  useEffect(() => {
    if (!EducationalUnits?.length) {
      setTemplate({
        schemaJson,
        UISchema,
      });
      return;
    }

    const educationalUnitVisibleName = {
      type: "string",
      oneOf: [
        ...EducationalUnits.map(({ visibleName }) => ({
          title: visibleName,
          const: visibleName,
        })),
      ],
    };
    setTemplate({
      schemaJson: {
        ...schemaJson,
        properties: { ...schemaJson.properties, educationalUnitVisibleName },
      },
      UISchema,
    });
  }, [EducationalUnits]);

  return {
    template,
  };
}
